var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('content-entity-quote');
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { ImageEntityBackground } from './image-entity-background';
import { useEntity } from '../hooks/use-entity';
import { useTheme } from '../hooks/use-theme';
import { get } from 'lodash';
import { useParallax } from 'react-scroll-parallax';
import { ThemeModeProvider } from '../context/theme-mode-context';
export var ContentEntityQuoteDefaultProps = {
  maxWidth: "950px",
  colors: {
    text: 'strong'
  },
  parallax: true,
  aspectRatio: {
    base: 3
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    line-height: 1.3em;\n    text-align: center;\n    position: relative;\n    font-size: ", "em;\n    font-family: ", ";\n    font-weight: 300;\n    b, strong {\n      color: inherit;\n    }\n  "], ["\n    ", ";\n    line-height: 1.3em;\n    text-align: center;\n    position: relative;\n    font-size: ", "em;\n    font-family: ", ";\n    font-weight: 300;\n    b, strong {\n      color: inherit;\n    }\n  "])), theme.APPLY_COLORS, 22 / 15, theme.FONT('serif'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    padding: ", " ", " ", ";\n    p, span {\n      margin-bottom: 1em;\n    }\n  "], ["\n    font-family: ", ";\n    padding: ", " ", " ", ";\n    p, span {\n      margin-bottom: 1em;\n    }\n  "])), theme.FONT('sans'), theme.UNIT(12), theme.UNIT(6), theme.UNIT(12)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme.UNIT(13), theme.UNIT(6), theme.UNIT(15))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    line-height: 1.3em;\n    text-shadow: none;\n    font-family: ", ";\n    font-weight: 500;\n    font-size: ", "em;\n  "], ["\n    line-height: 1.3em;\n    text-shadow: none;\n    font-family: ", ";\n    font-weight: 500;\n    font-size: ", "em;\n  "])), theme.FONT('serif'), 24 / 16)
});
var OutroStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 500;\n    text-shadow: none;\n    margin-top: ", ";\n    font-size: 1em;\n  "], ["\n    font-weight: 500;\n    text-shadow: none;\n    margin-top: ", ";\n    font-size: 1em;\n  "])), theme.UNIT(4))
});
var QuoteStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 2em;\n    font-family: ", ";\n    position: absolute;\n    height: 32px;\n    font-weight: 700;\n  "], ["\n    font-size: 2em;\n    font-family: ", ";\n    position: absolute;\n    height: 32px;\n    font-weight: 700;\n  "])), theme.FONT('serif')),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 3em;\n  "], ["\n    font-size: 3em;\n  "]))),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: 4em;\n  "], ["\n    font-size: 4em;\n  "])))
});
var StartQuoteStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    line-height: 0.75em;\n    left: ", ";\n    top: ", ";\n  "], ["\n    ", ";\n    line-height: 0.75em;\n    left: ", ";\n    top: ", ";\n  "])), QuoteStyles, theme.UNIT(6), theme.UNIT(6))
});
var EndQuoteStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    right: ", ";\n    bottom: ", ";\n    line-height: 2.8em;\n  "], ["\n    ", ";\n    right: ", ";\n    bottom: ", ";\n    line-height: 2.8em;\n  "])), QuoteStyles, theme.UNIT(6), theme.UNIT(6)),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    line-height: 2.5em;\n  "], ["\n    line-height: 2.5em;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(ImageEntityBackground)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Content: styled(ContentNode)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Outro: styled(ContentNode)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  StartQuote: styled.span.attrs(cls.attr('start-quote'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), StartQuoteStyles),
  EndQuote: styled.span.attrs(cls.attr('end-quote'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), EndQuoteStyles)
};
/**
 * Displays a `ContentEntity` (typically a `Slice`) in an "inspirational quote" style layout
 * which has a background image, the main content as the main quote content, and uses the `outro` field
 * to render final text after the quote, qwqhich is typically the person's name.
 * NB: This requires the `ParallaxProvider` from `react-scroll-parallax`, which provides a scrolling
 * effect for the main quote text.
 */
export var ContentEntityQuote = function (props) {
  var className = props.className,
    children = props.children,
    aspectRatio = props.aspectRatio,
    parallax = props.parallax,
    maxWidth = props.maxWidth;
  var entity = useEntity(props.entity);
  var theme = useTheme();
  var intro = entity.intro,
    content = entity.content,
    outro = entity.outro;
  var backgroundImages = get(entity, 'backgroundImages', []);
  var hasBackgroundImages = !!backgroundImages.length;
  var bodyStyle = {
    alignItems: 'center',
    justifyContent: 'center'
  };
  var colors = __assign(__assign({}, props.colors), {
    background: get(entity, 'backgroundColor.value'),
    color: get(entity, 'color.value')
  });
  var ref = useParallax({
    shouldAlwaysCompleteAnimation: true,
    translateY: ["-200px", "0px"],
    opacity: [0, 1.0]
  }).ref;
  return React.createElement(ThemeModeProvider, {
    value: hasBackgroundImages ? 'dark' : 'light'
  }, React.createElement(My.Container, {
    colors: colors,
    aspectRatio: aspectRatio,
    items: backgroundImages,
    overlayColor: hasBackgroundImages && "rgba(0,0,0,0.2)",
    bodyStyle: bodyStyle,
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.StartQuote, null, "\u201C"), React.createElement("div", {
    ref: parallax && ref
  }, React.createElement(My.Content, {
    entity: content
  })), React.createElement(My.Outro, {
    entity: outro
  }), React.createElement(My.EndQuote, null, "\u201D"))));
};
ContentEntityQuote.defaultProps = ContentEntityQuoteDefaultProps;
ContentEntityQuote.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;